import { Upgrade } from 'types';

export const getComparingUpgrade = (
	upgrades: Upgrade[],
	upgrade: Upgrade,
	basicUpgrade: Upgrade
): Upgrade => {
	const result = upgrades
		.filter((u) => u.vehicleData.trimLevel === upgrade.vehicleData.trimLevel)
		.sort((a, b) => a.monthPrice - b.monthPrice);

	// multiple upgrades with same trimLevel
	if (result.length >= 2) {
		const index = result.findIndex((r) => r.id === upgrade.id);

		// should be compared to cheaper upgrade with same trimLevel
		if (index > 0) {
			return result[index - 1];
		}
	}
	return basicUpgrade;
};
